import ArrangePuzzleGame from './ArrangePuzzleGame';
import LionsImage from '../../assets/lionsImage.jpg';

export default function LionsPuzzle() {
  return <ArrangePuzzleGame imageSrc={LionsImage} gameId="lionsImagePuzzle" />;
}
